import React from 'react';

const formatCurrency = (cents) => {
  if (cents >= 100) return `$${(cents / 100).toFixed(2)}`;
  return `${cents}¢`;
};

export const UserOrdersAndPositions = ({
  isAuthenticated,
  userOrders,
  userPositions,
  yesPrice,
  noPrice,
  onCancelOrder,
}) => {
  if (!isAuthenticated) return null;

  const openOrders = userOrders.filter(o => o.status === 'open');

  return (
    <>
      {openOrders.length > 0 && (
        <div className="bg-[#131b2e] rounded-xl p-4">
          <h4 className="text-sm font-semibold text-white mb-3">Your Open Orders</h4>
          <div className="space-y-2">
            {openOrders.map(order => (
              <div key={order.id} className="flex items-center justify-between bg-[#1e2a45]/50 rounded-lg p-2 text-sm">
                <div>
                  <span className={order.side === 'buy' ? 'text-green-400' : 'text-red-400'}>
                    {order.side.toUpperCase()}
                  </span>
                  {' '}
                  <span className={order.outcome === 'YES' ? 'text-[#3B82F6]' : 'text-[#F97316]'}>
                    {order.remaining_quantity} {order.outcome}
                  </span>
                  {' @ '}
                  <span className="text-white">{order.price}¢</span>
                </div>
                <button
                  onClick={() => onCancelOrder(order.id)}
                  className="text-red-400 hover:text-red-300 text-xs"
                >
                  Cancel
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      {userPositions.length > 0 && (
        <div className="bg-[#131b2e] rounded-xl p-4">
          <h4 className="text-sm font-semibold text-white mb-3">Your Positions</h4>
          <div className="space-y-2">
            {userPositions.map(pos => (
              <div key={pos.id} className="flex items-center justify-between bg-[#1e2a45]/50 rounded-lg p-2 text-sm">
                <div className="flex items-center gap-2">
                  <span className={pos.outcome === 'YES' ? 'text-[#3B82F6]' : 'text-[#F97316]'}>
                    {pos.shares} {pos.outcome}
                  </span>
                  <span className="text-gray-500">@ avg {formatCurrency(pos.avg_price)}</span>
                </div>
                <div className="text-right">
                  <div className="text-white">{formatCurrency(pos.shares * (pos.outcome === 'YES' ? yesPrice : noPrice))} value</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};
